export default __webpack_public_path__ + "static/media/cloud1.bc8a357b.png";